import { EBitfStoreActions } from '@common/enums';
export enum EWebStoreActions {
  LOAD_BOOKLET = 'LOAD_BOOKLET',
  BOOKLET_UPDATED = 'BOOKLET_UPDATED',
}

export const eStoreActions = { ...EBitfStoreActions, ...EWebStoreActions };
